import React from "react";
import UserNavbar from "../../components/common/UserNavbar";
import UserFooter from "../../components/common/UserFooter";
import useScrollToTop from "../../hooks/useScrollToTop";
import FloatingWhatsApp from "../../components/common/FloatingWhatsApp";

const UserLayout = (props) => {
   useScrollToTop();

  return (
    <React.Fragment>
      <UserNavbar />
      {props.children}
      <UserFooter />

      <FloatingWhatsApp/>
    </React.Fragment>
  );
};

export default UserLayout;
